export const onMapChangeState = {};
